import { ErrorResponseErrorItemCodeDynamicAsset } from '../../../../typings/api/skymap/rest/v1/.common';

export const translations: Record<ErrorResponseErrorItemCodeDynamicAsset, string> = {
  'dynamic_asset:not_found': 'Objektet existerar inte.',
  'dynamic_asset:invalid_asset_for_duplication': 'Objektet stödjer att dupliceras.',
  'dynamic_asset:geometry_not_found': 'Objektet saknar koppling till en geometri.',
  'dynamic_asset:not_connected_to_file': 'Objektet saknar koppling till en fil.',
  'dynamic_asset:missing_skymap_information_model': 'Objektet saknar en geometri.',
  'dynamic_asset:user_unauthorized': 'Användaren har inte tillgång till objektet.',
  'dynamic_asset:unsupported_export_format':
    'Objektet stödjer inte export till det valda formatet.',
  'dynamic_asset:invalid_asset_for_transformation':
    'Objektet stödjer inte transformation med skalningsverktyget.',
  'dynamic_asset:line_has_invalid_coordinates_count': 'Linjen kräver minst två koordinater.',
  'dynamic_asset:area_has_invalid_coordinates_count': 'Arean kräver minst tre koordinater.',
  'dynamic_asset:volume_incompatible_asset':
    'Det valda objektet har inte stöd för den här typen av volymberäkning.',
  'dynamic_asset:volume_target_and_source_different_project':
    'Båda ytorna för volymberäkningen måste tillhöra samma projekt.',
  'dynamic_asset:volume_target_and_source_same_asset':
    'De valda ytorna för volymberäkningen får inte vara del av samma objekt.',
  'dynamic_asset:prism_volume_not_found': 'Volymen existerar inte.',
};
